export default __webpack_public_path__ + "8f28709971ba4fa8bbbf346c6be701dc.png";